import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api/client';

export function useFlicButtonManagement(tableId: string) {
  const queryClient = useQueryClient();

  const buttonsQuery = useQuery({
    queryKey: ['tables', tableId, 'buttons'],
    queryFn: () => api.getTableButtons(tableId),
    enabled: !!tableId,
  });

  const assignButtonMutation = useMutation({
    mutationFn: (payload: { serialNumber: string; buttonType: 'sideA' | 'sideB' }) =>
      api.assignButton(tableId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tables', tableId, 'buttons'] });
    },
  });

  const removeButtonMutation = useMutation({
    mutationFn: (buttonId: string) => api.removeButton(tableId, buttonId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tables', tableId, 'buttons'] });
    },
  });

  return {
    buttons: buttonsQuery.data?.buttons || [],
    isLoading: buttonsQuery.isLoading,
    isError: buttonsQuery.isError,
    error: buttonsQuery.error,
    assignButton: assignButtonMutation.mutateAsync,
    removeButton: removeButtonMutation.mutateAsync,
    isAssigning: assignButtonMutation.isPending,
    isRemoving: removeButtonMutation.isPending,
  };
}
